(function () {
  class TeamVote extends HTMLElement {
    connectedCallback() {
      this.options = Array.from(this.querySelectorAll('.team-vote__option'));
      this.medias = Array.from(this.querySelectorAll('.team-vote__media'));
      this.voteButton = this.querySelector('.team-vote__button');
      this.noteEl = this.querySelector('[data-vote-note]');

      // 优先用后台配置的 server_url，否则自动拼接 api.torraslife.com
      this.serverUrl = this.dataset.serverUrl
        || (window.TORRAS_API_BASE ? window.TORRAS_API_BASE + '/api/team-vote' : '');

      this.redirectUrl = this.voteButton ? this.voteButton.dataset.voteLink || '' : '';
      this.activeIndex = '0';

      if (!this.options.length || !this.medias.length) return;

      this.handleClick = this.handleClick.bind(this);
      this.handleVote = this.handleVote.bind(this);
      this.options.forEach(function (option) { option.addEventListener('click', this.handleClick); }.bind(this));
      if (this.voteButton) {
        this.voteButton.addEventListener('click', this.handleVote);
      }

      // localStorage 防重复投票
      this.voteKey = 'team-vote-' + (this.dataset.sectionId || this.id);
      this.hasVoted = localStorage.getItem(this.voteKey) !== null;
      if (this.hasVoted) {
        var savedIndex = localStorage.getItem(this.voteKey);
        if (savedIndex !== null) this.activate(savedIndex);
        this.disableVoting();
      }
    }

    disconnectedCallback() {
      if (!this.options) return;
      this.options.forEach(function (option) { option.removeEventListener('click', this.handleClick); }.bind(this));
      if (this.voteButton) {
        this.voteButton.removeEventListener('click', this.handleVote);
      }
    }

    handleClick(event) {
      if (this.hasVoted) return;
      var index = event.currentTarget.getAttribute('data-team-index');
      if (index == null) return;
      this.activeIndex = index;
      this.activate(index);
    }

    activate(index) {
      var self = this;
      this.options.forEach(function (option) {
        var isActive = option.getAttribute('data-team-index') === index;
        option.classList.toggle('is-active', isActive);
        option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      this.medias.forEach(function (media) {
        media.classList.toggle('is-active', media.getAttribute('data-team-index') === index);
      });
    }

    handleVote(event) {
      event.preventDefault();
      if (this.hasVoted) return;
      if (!this.serverUrl) return;

      var self = this;
      var activeOption = this.options.find(function (opt) {
        return opt.getAttribute('data-team-index') === self.activeIndex;
      });
      if (!activeOption) return;

      var teamLabelEl = activeOption.querySelector('.team-vote__option-label');
      var teamLabel = teamLabelEl ? teamLabelEl.textContent.trim() : '';

      this.setSubmitting(true);

      fetch(this.serverUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          team_index: parseInt(this.activeIndex, 10),
          team_label: teamLabel,
          section_id: this.dataset.sectionId || this.id,
          page_url: window.location.href,
          // 登录用户带上邮箱，未登录为空字符串（后端会存为 null）
          email: (this.dataset.customerEmail || '').trim()
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Server responded with ' + response.status);
          return response.json();
        })
        .then(function () {
          self.hasVoted = true;
          localStorage.setItem(self.voteKey, self.activeIndex);
          self.disableVoting();
          self.showFeedback(true);
          if (self.redirectUrl) {
            setTimeout(function () { window.location.href = self.redirectUrl; }, 800);
          }
        })
        .catch(function (error) {
          console.error('TeamVote: submission failed', error);
          self.setSubmitting(false);
          self.showFeedback(false);
        });
    }

    setSubmitting(loading) {
      if (!this.voteButton) return;
      this.voteButton.disabled = loading;
      if (loading) {
        if (!this.voteButton.dataset.originalText) {
          this.voteButton.dataset.originalText = this.voteButton.textContent;
        }
        this.voteButton.textContent = 'Submitting\u2026';
      } else {
        this.voteButton.textContent = this.voteButton.dataset.originalText || this.voteButton.textContent;
      }
    }

    disableVoting() {
      this.options.forEach(function (opt) { opt.disabled = true; });
      if (this.voteButton) {
        this.voteButton.disabled = true;
        this.voteButton.textContent = 'Vote Submitted';
      }
    }

    showFeedback(success) {
      var el = this.noteEl;
      if (!el) {
        el = document.createElement('div');
        el.className = 'team-vote__note rte';
        el.setAttribute('data-vote-note', '');
        var cta = this.querySelector('.team-vote__cta');
        if (cta) {
          cta.appendChild(el);
        } else {
          this.querySelector('.team-vote__panel--content').appendChild(el);
        }
        this.noteEl = el;
      }
      el.innerHTML = success
        ? '<p>Thank you for voting!</p>'
        : '<p>Something went wrong. Please try again.</p>';
    }
  }

  if (!customElements.get('team-vote')) {
    customElements.define('team-vote', TeamVote);
  }
})();
